import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { confetti, playFanfare } from "@/lib/celebrate";
import { whenFree } from "@/lib/popupQueue";
import { SkyCanvas } from "@/components/sky/SkyCanvas";

const KEY = "itz_sky_seen";
const seen = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };

export function SkyCelebration() {
  const [ev, setEv] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/sky").then(({ data }) => {
      const c = (data.celebrations || []).filter((x) => !seen().includes(x.key)).sort((a, b) => b.at.localeCompare(a.at))[0];
      if (!c) return;
      whenFree(`sky-${c.key}`, () => {
        localStorage.setItem(KEY, JSON.stringify([...seen(), c.key].slice(-30)));
        setEv({ ...c, sky: data });
        playFanfare();
        [0, 400, 800].forEach((d, i) => setTimeout(() => confetti({ x: innerWidth * [0.5, 0.2, 0.8][i], y: innerHeight * 0.3, count: 80, spread: 1.8, colors: ["#fde68a", "#f9a8d4", "#ffffff", "#c4b5fd"] }), d));
      });
    }).catch(() => {});
  }, []);
  if (!ev) return null;
  const close = (go) => { setEv(null); if (go) navigate("/sternenhimmel"); };
  return createPortal(
    <div className="fixed inset-0 z-[86] flex items-center justify-center p-4 bg-[#05030f]/85 backdrop-blur-md wheel-fade" data-testid="sky-celebration">
      <div className="sky-celebrate w-full max-w-md rounded-[2rem] overflow-hidden bg-[#0b0820] text-white text-center">
        <SkyCanvas sky={ev.sky} />
        <div className="p-6 space-y-3">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.3em] text-pink-300 flex items-center justify-center gap-1.5"><Sparkles className="w-3.5 h-3.5" /> Gemeinsam geschafft</p>
          <h2 className="font-display text-3xl font-extrabold sky-celebrate-title" data-testid="sky-celebration-title">Sternbild „{ev.name}“ leuchtet!</h2>
          <p className="text-sm text-indigo-100" data-testid="sky-celebration-text">{ev.helpers} {ev.helpers === 1 ? "Mitglied hat" : "Mitglieder haben"} es zusammen zum Strahlen gebracht – alle Mitwirkenden bekommen {ev.sky.bonus} Bonuspunkte. ✨</p>
          <button onClick={() => close(true)} data-testid="sky-celebration-go" className="w-full h-12 rounded-full bg-gradient-to-r from-pink-400 via-amber-200 to-pink-300 text-indigo-950 font-extrabold">Zum Sternenhimmel</button>
          <button onClick={() => close(false)} data-testid="sky-celebration-close" className="text-sm font-semibold text-indigo-200 hover:text-white">Wunderschön!</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
